<ng-container *ngIf="!isLoading; else loadingTemplate">

  <div [ngClass]="isMobile ? 'mobile-header' : 'header'">
    <app-external-header
      style="width: 100%; z-index: 1000; position: relative;"
      [isInboxPresent]="true"
      [isCompanyProfile]="true"
      [isMobile]="isMobile"
      [isProfile]="false"
      [showButtons]="false"
      [showProfilePicture]="true"
    ></app-external-header>
  </div>

  <div class="jobs-wrapper">
    <h1 class="page-title">{{ 'jobs.title' | translate }}</h1>
    <ng-container *ngIf="jobs.length > 0; else noJobs">
      <div class="job-list">
        <div
          class="job-card"
          *ngFor="let job of jobs"
          [routerLink]="'/jobs/' + job.id"
        >
          <app-job style="width:100%; padding: 1rem;" [job]="job"></app-job>
        </div>
      </div>
    </ng-container>

    <ng-template #noJobs>
      <div class="no-jobs-message">
        {{ 'jobs.no_jobs' | translate }}
      </div>
    </ng-template>
  </div>
</ng-container>

<div class="footer-class footer-container">
  <app-footer></app-footer>
</div>

<ng-template #loadingTemplate>
  <app-load-mask></app-load-mask>
</ng-template>
